import { Api } from '@/api/api';
import { Quote } from '@/models/quote';
import { QuoteFilters } from '@/models/quote-filters';
import { PagedQuoteResult } from '@/models/paged-quote-result';
import { QuoteHistory } from '@/models/quote-history';

export class QuoteApi extends Api {
    public async fetchForUserAsync(userId: number, filters: QuoteFilters): Promise<PagedQuoteResult> {
        return await this.getAsync<PagedQuoteResult>(`v2/user/${userId}/quotes`, filters);
    }
    public async fetchAsync(filters: QuoteFilters): Promise<PagedQuoteResult> {
        return await this.getAsync<PagedQuoteResult>('v2/quote', filters);
    }
    public async fetchByIdAsync(id: string): Promise<Quote> {
        return await this.getAsync<Quote>('v2/quote/' + id);
    }
    public async fetchHistoryByIdAsync(id: string): Promise<Array<QuoteHistory>> {
        return await this.getAsync<Array<QuoteHistory>>(`v2/quote/${id}/history`);
    }
    public async createAsync(enquiry: Quote): Promise<string> {
        const location = await this.postAsync<string>('v2/quote', enquiry);
        const id = location.replace(this.buildUrl('v2/quote/'), '');
        return id;
    }
}
